export { default as Modal } from "./ModalBody";
